import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router'
import Actions from '../../../actions'
import ListView from '../../common/ListView'
import dayjs from 'dayjs'
import $t from '../../../i18n'
import { useRouteMatch } from 'react-router'
import FilePreviewPage from '../FilePreviewPage'
import Page from '../../common/Page'
import { eventTypes, event } from '../../../consts/eventConsts'

import './Consents.css'

const Consents = () => {
  const dispatch = useDispatch()
  const { path, url } = useRouteMatch()
  const selectedMemberId = useSelector(
    state => state.account?.selectedMember?.id
  )
  const concents = useSelector(state => state.medicalInfo?.currentConsents)
  const isLoading = useSelector(state => state.medicalInfo?.isLoadingDocs)

  const [concentsList, setConcentsList] = useState([])

  useEffect(() => {
    dispatch(
      Actions.createAction(Actions.SET_CONSENTS_BY_ID, {
        id: selectedMemberId,
      })
    )
  }, [selectedMemberId])

  useEffect(() => {
    const data = concents?.map(c => {
      const fileId = c?.file || 0
      const isHmoConsent = c?.file_type === 'oh_consent'
      return {
        issueDate: dayjs(c?.creationDate).format('DD MMM YYYY'),
        title: isHmoConsent
          ? `${$t('pages.consents.type')} | ${$t('dialogs.consentHMO.title')}`
          : $t('pages.consents.type'),
        shouldHideClinicName: isHmoConsent,
        doctor: c?.doctor,
        dateRange: '',
        isPressable: !!fileId,
        patientId: c?.patient,
        onClick: () => {
          dispatch(
            Actions.createAction(Actions.NAVIGATED_TO, `${url}/${fileId}`)
          )
          dispatch(
            Actions.createAction(Actions.ANALYTICS_EVENT_FIRED, {
              type: eventTypes.click,
              eventName: event.clickEvent.click,
              element: 'Consent opening screen - ' + fileId,
            })
          )
        },
      }
    })
    setConcentsList(data)
  }, [concents])

  return (
    <div className="my-concents">
      <Switch>
        <Route exact path={path}>
          <Page title={$t('pages.consents.consents')} className="grey">
            <ListView
              data={concentsList}
              dataName="consent"
              isLoading={isLoading}
              category={$t('pages.consents.consents').toLowerCase()}
            />
          </Page>
        </Route>
        <Route path={`${path}/:fileId`}>
          <FilePreviewPage />
        </Route>
      </Switch>
    </div>
  )
}

export default Consents
